export default __webpack_public_path__ + "static/media/mongoDB.15d9a29a.png";